// extracted by mini-css-extract-plugin
export default {"embeddedPlayer":"style_embeddedPlayer__zKShO","embeddedPlayerWrap":"style_embeddedPlayerWrap__JRxYd"};